export default (datas, key) => {
  const obj = {};
  datas.forEach((data) => {
    obj[data[key]] = data;
  })

  return obj;
}